<template>
  <div class="home-box">
    <PageTitleWithSearch
      :title="'Clubs'"
      :loading="loading"
      :search="search"
      @searchText="searchChange($event)"
    ></PageTitleWithSearch>
    <v-card v-if="!loading && clubs">
      <v-card-title dark class="pa-2">
        <v-spacer></v-spacer>
        <v-btn
          small
          depressed
          class="white--text"
          color="blue"
          title="Add"
          :to="'/clubs/create'"
          v-if="
            role === 'REGION_CHAIRPERSON' ||
              role === 'CABINET_SECRETARY' ||
              role === 'REGION_GMT_COORDINATOR' ||
              role === 'ZONE_CHAIRPERSON' ||
              role === 'CLUBS_PERFORMANCE_EVALUATION' ||
              role === 'DISTRICT_GLOBAL_clubsHIP_TEAM_COORDINATOR'
          "
        >
          Create New Club
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div>
        <v-simple-table v-if="clubs">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" width="25%">
                  Club Region
                </th>
                <th class="text-left" width="25%">
                  Club Zone
                </th>
                <th class="text-left " width="25%">
                  Club Name
                </th>
                <th width="10%" class="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in clubs" :key="item.uuid">      
                <td class="text-left" v-if="item.zone && item.zone.region">{{ item.zone.region.name }}</td>
                <td class="text-left" v-if="item.zone">{{ item.zone.name }}</td>
                <td class="text-left">{{ item.name }}</td>                
                <td class="text-center">
                  <div class="d-flex justify-center align-center">
                    <v-btn
                      small
                      dark
                      color="green"
                      fab
                      title="QR Code"
                      class="mx-1"
                      v-if="canViewQr()"
                      @click="openQrDialog(item)"
                    >
                      <v-icon small>mdi-qrcode-scan</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="canEdit()"
                      color="orange"
                      :to="'/clubs/edit/' + item.uuid"
                      fab
                      small
                      dark
                      class="mx-1"
                    >
                      <v-icon small> mdi-pencil </v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    <v-card class="pl-5 pr-5">
      <Pagination
        @previous="page--"
        @next="page++"
        :loading="loading"
        :total="total"
        :page="page"
      ></Pagination>
    </v-card>
    <ClubQrCode
      v-model="qrDialog"
      :uuid="selectedClub ? selectedClub.uuid : ''"
      :name="selectedClub ? selectedClub.name : ''"
    ></ClubQrCode>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { CommonService } from "../../services/common-service.js";
import { checkError } from "@/config/errors.js";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Pagination from "@/components/shared/Pagination";
import ClubQrCode from "@/components/clubs/ClubQrCode";

export default {
  name: "MemberGrid",
  components: { PageTitleWithSearch, Pagination, ClubQrCode },
  data: function() {
    return {
      clubs: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      qrDialog: false,
      selectedClub: null,
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getClubs();
  },

  watch: {
    search() {
      this.page = 1;
      this.getClubs();
    },
    page() {
      this.getClubs();
    },
  },

  methods: {
    getClubs() {
      this.loading = true;
      CommonService.getClubList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.clubs = response.data.data;
            this.total = response.data.meta.last_page || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.clubs = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "active":
          bgColor = "green";
          break;
        default:
          bgColor = "red";
          break;
      }

      return bgColor;
    },

    searchChange(value) {
      this.search = value;
    },

    openQrDialog(item) {
      this.selectedClub = item;
      this.qrDialog = true;
    },

    canViewQr() {
      return (
        this.role === "CLUBS_PERFORMANCE_EVALUATION" ||
        this.role === "CABINET_SECRETARY"
      );
    },

    canEdit() {
      return (
        this.role === "REGION_CHAIRPERSON" ||
        this.role === "CABINET_SECRETARY" ||
        this.role === "REGION_GMT_COORDINATOR" ||
        this.role === "ZONE_CHAIRPERSON" ||
        this.role === "CLUBS_PERFORMANCE_EVALUATION" ||
        this.role === "DISTRICT_GLOBAL_clubsHIP_TEAM_COORDINATOR"
      );
    },
  },
};
</script>
